class GiftBoxOption extends HTMLElement {
  connectedCallback() {
    this.checkbox = this.querySelector('input[type="checkbox"]');

    const formId = this.dataset.formId;
    this.form = formId ? document.getElementById(formId) : this.closest('product-form')?.querySelector('form');

    if (!this.form) {
      return;
    }

    this.onVariantAdd = this.onVariantAdd.bind(this);
    this.form.addEventListener('variant:add', this.onVariantAdd);

    this.statusTarget = this.dataset.statusTarget ? document.getElementById(this.dataset.statusTarget) : null;

    if (this.statusTarget && this.checkbox) {
      this.onStatusChange = this.onStatusChange.bind(this);
      this.checkbox.addEventListener('change', this.onStatusChange);
      this.onStatusChange();
    }
  }

  disconnectedCallback() {
    this.form?.removeEventListener('variant:add', this.onVariantAdd);
    this.checkbox?.removeEventListener('change', this.onStatusChange);
  }

  onStatusChange() {
    this.statusTarget.textContent = this.checkbox.checked ? this.dataset.addedText : this.dataset.notAddedText;
  }

  async onVariantAdd() {
    if (!this.checkbox?.checked) {
      return;
    }

    const variantId = this.dataset.variantId;
    const productTitle = this.dataset.productTitle;

    if (!variantId) {
      return;
    }

    try {
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: {
                'Gift box for': productTitle
              }
            }
          ]
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add gift box to cart');
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (error) {
      console.error(error);
    }
  }
}

if (!window.customElements.get('gift-box-option')) {
  window.customElements.define('gift-box-option', GiftBoxOption);
}
